const paths = {
  arrow: 'M4 12h15M13 5l7 7-7 7',
  arrowUp: 'M5 19 19 5M5 5h14v14',
  check: 'm5 12 4 4L19 6',
  plus: 'M12 5v14M5 12h14',
  home: 'm3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1Z',
  users:
    'M9 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM3 20v-2a6 6 0 0 1 12 0v2M16 5a3 3 0 0 1 0 6m2 3a5 5 0 0 1 3 4v2',
  calendar:
    'M6 5h12a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3ZM7 3v4m10-4v4M3 10h18M7 14h2m4 0h2m-8 4h2',
  list: 'M7 3h10a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Zm0 6 1 1 2-3m3 2h4m-10 6 1 1 2-3m3 2h4',
  box: 'm12 3 9 5v9l-9 5-9-5V8l9-5Zm0 9 9-4m-9 4L3 8m9 4v10m-5-17 9 5',
  coins: 'M6 5h12a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3ZM3 9h18m-6 5h3',
  shield: 'm12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6l8-3Zm-4 9 3 3 5-6',
  leaf: 'M19 4C8 2 3 8 6 15s13 5 13-11ZM5 21 15 10',
  folder: 'M3 7V5a2 2 0 0 1 2-2h5l3 4h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z',
  mail: 'M6 5h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3Zm-3 2 9 7 9-7',
  tag: 'M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9-9-9Zm5-4.5v.1',
  settings:
    'M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm7.4 6a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-2.9 1.2V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-2.9-1.2l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1A1.7 1.7 0 0 0 3 14H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.2-2.9l-.1-.1A2 2 0 1 1 7 4.2l.1.1A1.7 1.7 0 0 0 10 3.1V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 2.9 1.2l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1A1.7 1.7 0 0 0 21 10h.1a2 2 0 1 1 0 4H21a1.7 1.7 0 0 0-1.6 1Z',
  candle: 'M9 10h6v11H9zM12 3c1.5 2 1.5 3.5 0 5-1.5-1.5-1.5-3 0-5ZM6 21h12',
  card: 'M5 5h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3ZM2 10h20M6 15h4',
  logout: 'M9 4H4v16h5m6-12 4 4-4 4m-6-4h10',
  lock: 'M8 10h8a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3v-5a3 3 0 0 1 3-3Zm0 0V7a4 4 0 0 1 8 0v3m-4 4v3',
} as const;

export type IconName = keyof typeof paths;

export function Icon({ name, size = 18 }: { name: IconName; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.65}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={paths[name]} />
    </svg>
  );
}

export function Brand() {
  return (
    <span className="brand" aria-label="Zeladoria">
      <svg className="brand-symbol" viewBox="0 0 36 43" fill="none" aria-hidden="true">
        <path
          d="M5 39V20a13 13 0 0 1 26 0v19M12 39V21a6 6 0 0 1 12 0v18"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path d="M18 12c0-5 3-9 9-9 0 5-3 9-9 9Z" fill="currentColor" />
        <path d="M3 39h30" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <span className="brand-word">zeladoria</span>
    </span>
  );
}
